module.exports = __webpack_public_path__ + "static/bg.f07260f4.png";